export default __webpack_public_path__ + "static/media/4.f64eab06.jpeg";